module.exports = __webpack_public_path__ + "img/CelticAnglianWater.f3825d79.jpg";